import React from 'react'
import "../TodosSchedule/TodosSchedule.css"

import TodoListItem from '../../TodosPage/TodoListItem/TodoListItem'
import { ITodo, ITodoSchedule, TodoObj } from '../../../types/interfaces'
import Drawer from '../../Drawer/Drawer'
import useDrawer from '../../../hooks/useDrawer'
interface TodosScheduleProps{
  title: string,
  description: string,
  todosArr: ITodo[],
  scheduleDateTime: string,
  scheduleKey: string,
  deleteCallback: ((id: number) => void),
  editCallback:((scheduleData:ITodoSchedule)=> void)
}
export default function TodosSchedule({
  title, description, todosArr, scheduleDateTime, scheduleKey,
  deleteCallback,editCallback }: TodosScheduleProps) {
  function DeleteSchedule() {
    deleteCallback(parseInt(scheduleKey))
  }
  function EditSchedule() {
    editCallback({
      id:parseInt(scheduleKey),
      title: title,
      description: description,
      scheduleDate: scheduleDateTime,
      todosArr: todosArr,
      project: ''
    })
  }
  return (
    <>
      
      <div className='Schedule-Container' id={scheduleDateTime.split(" ").join("%20")}>
        <h3 className='Schedule-Title'>{title}</h3>
        <b className='Schedule-Date'><br />{scheduleDateTime}</b>
        <p className='Schedule-Description'>{description}</p>
        <div className='Schedule-Btns'>
          <button className='Delete-ScheduleBtn' onClick={DeleteSchedule}>Delete Schedule</button>
          <button className='Edit-ScheduleBtn' onClick={EditSchedule}>Edit Schedule</button>
        </div>
        <div className='Schedule-Todos-List-Container'>
          <h4>Todos :</h4>
          <ul className='Schedule-Todos-List'>
            
            {
              todosArr.map((todo, i) => {
                return (
                  <li key={i}>{todo.title}</li>
                )
              })
            }
            
          </ul>
        </div>
        
      </div>
    </>
    
  )
}
